var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchmansCentralStation01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.65,11.54H4.56V4.46h7.09V11.54z M5.06,11.04h6.09V4.96H5.06V11.04z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.12,9.65L6.39,6.78h0.39l0.34,1.45c0.08,0.36,0.16,0.72,0.21,0.99h0.01c0.05-0.29,0.14-0.63,0.23-1 l0.38-1.45h0.39L8.7,8.23c0.08,0.34,0.16,0.68,0.2,0.98h0.01C8.97,8.9,9.05,8.58,9.14,8.22l0.38-1.45H9.9L9.08,9.65H8.7 L8.33,8.15C8.24,7.79,8.18,7.5,8.15,7.21H8.14C8.09,7.5,8.02,7.78,7.92,8.15L7.51,9.65H7.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "14.01,11.52 11.19,11.52 11.19,11.02 13.51,11.02 13.51,4.96 11.4,4.96 11.4,4.46 14.01,4.46  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "4.94,11.52 1.99,11.52 1.99,4.46 4.72,4.46 4.72,4.96 2.49,4.96 2.49,11.02 4.94,11.02  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchmansCentralStation01);
export default __webpack_public_path__ + "static/media/WatchmansCentralStation-01.9a4c655f88ab7710c9da7ac691f372d1.svg";
export { ForwardRef as ReactComponent };